import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useNavigate} from 'react-router-dom';
import {LeftOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Checkbox, Form} from 'antd';
import PhoneInput from 'antd-phone-input';
import dayjs from 'dayjs';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import {CODE, DELETE_ACCOUNT, POLICY} from '../../config/routes';

import {sendCode, sendCodeVariables} from './__generated__/sendCode';
import {MUTATION_SEND_CODE} from './auth';

interface ILoginForm {
    phone: any;
}

export const Login = () => {

    const [agreed, setAgreed] = useState(false);
    const [wait, setWait] = useState<boolean>(false)
    const [time, setTime] = useState<dayjs.Dayjs>(dayjs());
    const [sendingDate, setSendingDate] = useState<dayjs.Dayjs>(dayjs());

    const {t} = useTranslation();

    useEffect(() => {
        const interval = setInterval(() => setTime(dayjs()), 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);

    const navigate = useNavigate();

    const [createCode, {loading}] = useMutation<sendCode, sendCodeVariables>(MUTATION_SEND_CODE);

    // @ts-ignore
    const validator = (_, {valid}) => {
        // if (valid(true)) return Promise.resolve(); // strict validation
        if (valid(true)) return Promise.resolve(); // non-strict validation
        return Promise.reject(t('Invalid format'));
    }

    const onFinish = async (data:ILoginForm) => {

        console.log('data', data);
        const phoneFormat = `+${data.phone.countryCode}${data.phone.areaCode}${data.phone.phoneNumber}`

        await createCode({
            variables: {
                phone: phoneFormat,
            },
            onCompleted: (res) => {
                if (res.sendCode.done) {
                    navigate(CODE, {state: {phone: phoneFormat}});
                }
            },
            onError: (error) => {
                if (error.message === 'Await') {
                    setWait(true)
                    setSendingDate(dayjs())
                }
            }
        })
    }

    const awaitSeconds = sendingDate.diff(dayjs().add(-5, 'minutes'), 'seconds')
    console.log(time)

    return (
        <Layout header={<Header left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>} title={'Вход'}/>}>
            <Form layout={'vertical'} onFinish={onFinish} validateTrigger={'onFinish'}>
                <Form.Item name={'phone'} label={'Номер телефона'} rules={[
                    {required: true, message: 'Заполните, пожалуйста'},
                    {validator}
                ]}>
                    <PhoneInput enableSearch preferredCountries={['ru']} country={'ru'}/>
                </Form.Item>
                <Form.Item>
                    <Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)}><Link to={POLICY}>{t('I agree with the Privacy Policy')}</Link></Checkbox>
                </Form.Item>
                <Form.Item>
                    <Button loading={loading} disabled={!agreed} htmlType={'submit'} type={'primary'}>{t('Next')}</Button>
                </Form.Item>
                {wait &&
                    <Form.Item>
                        <div className={'caption'}>
                            {awaitSeconds > 0 &&
                                `Отправить повторно через ${Math.floor(awaitSeconds/60)}:${awaitSeconds%60}`
                            }
                        </div>
                    </Form.Item>
                }
                <p>
                    <sup>*</sup> Вы можете отозвать свое согласие в любое время, связавшись с нами по адресу <a href={'mailto:support@aevitas.space'}>support@aevitas.space</a>
                </p>
                <p>
                    <sup>**</sup> Чтобы удалить аккаунт, перейдите по <Link to={DELETE_ACCOUNT}>ссылке</Link>
                </p>

            </Form>
        </Layout>

    )
}